import { LeadTranslate } from './leadTranslate.model';

const leadTranslatePTBR: LeadTranslate = {
  header: {
    label: {
      search: 'Digite um nome ou email',
    },
  },
  list: {
    title: 'Clientes',
    searchPlaceholder: 'Busque por nome, e-mail, telefone ou Instagram',
    dotsOptions: {
      activate: 'Ativar',
      deactivate: 'Inativar',
      detail: 'Detalhar',
    },
    emptyState: 'Não encontramos nenhum usuário',
    emptyStateDetail: 'Tente outro nome ou email!',
    tooltip: {
      instagram: 'Visitar Instagram',
    },
    filters: {
      source: 'Origem',
      sourceAll: 'Todas as origens',
      clear: 'Limpar filtros',
    },
  },
  details: {
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
    },
    buttons: {
      addEvent: 'Novo evento',
      addTodo: 'Nova tarefa',
      edit: 'Editar',
      activate: 'Ativar',
      deactivate: 'Inativar',
      message: 'Mensagem',
      back: 'Voltar para a lista de leads',
    },
    notFound: {
      title: 'Lead não encontrado',
      description:
        'Ele pode ter sido removido ou o endereço acessado está incorreto.',
      backToList: 'Voltar para a lista',
    },
    label: {
      email: 'E-mail',
      instagram: 'Instagram',
      phone: 'Contato',
      createdAt: 'Data de criação',
      notes: 'Observação',
      events: 'Eventos',
      source: 'Origem',
      referrer: 'Indicado por',
      lostReason: 'Motivo de perda',
      lostReasonNote: 'Observação da perda',
    },
    contact: {
      email: 'Enviar e-mail',
      whatsapp: 'Abrir WhatsApp',
      call: 'Ligar',
    },
    tooltip: {
      instagram: 'Visitar Instagram',
    },
    tabs: {
      sectionLabel: 'Seção',
      general: 'Dados Gerais',
      events: 'Eventos',
      sales: 'Vendas',
      eventsEmpty: 'Nenhum evento cadastrado',
    },
  },
  modal: {
    deactivate: {
      title: 'Inativar',
      text: 'Tem certeza que deseja inativar este cliente?',
      secondaryText: 'Todos os eventos associados serão cancelados',
      confirmButtonText: 'Sim, desejo inativar',
      cancelButtonText: 'Cancelar',
    },
  },
  widget: {
    title: 'Clientes recentes',
    viewAll: 'Ver todos',
    empty: 'Nenhum cliente cadastrado',
    createdAt: 'criado {{distance}}',
    addNew: 'Novo cliente',
  },
  source: {
    INSTAGRAM: 'Instagram',
    FACEBOOK: 'Facebook',
    TIKTOK: 'TikTok',
    GOOGLE: 'Google',
    SITE: 'Site',
    INDICACAO: 'Indicação',
    OUTRO: 'Outro',
  },
  reviewStatus: {
    title: 'Avaliação no Google',
    description: 'Acompanhe o pedido de avaliação deste cliente.',
    field: 'Status da avaliação',
    updateError: 'Não foi possível atualizar o status da avaliação',
    option: {
      NOT_REQUESTED: 'Não solicitada',
      REQUESTED: 'Solicitada',
      RECEIVED: 'Recebida',
    },
    chip: {
      REQUESTED: 'Avaliação solicitada',
      RECEIVED: 'Avaliação recebida',
    },
  },
  lostReason: {
    PRECO: 'Preço',
    AGENDA: 'Agenda',
    CONCORRENTE: 'Concorrente',
    SEM_RETORNO: 'Sem retorno',
    DESISTIU: 'Desistiu',
    OUTRO: 'Outro',
  },
  deactivate: {
    title: 'Inativar cliente',
    description:
      'Opcionalmente registre o motivo da perda. Todos os eventos associados serão cancelados.',
    reasonPlaceholder: 'Motivo da perda',
    reasonNone: 'Sem motivo',
    notePlaceholder: 'Observação (opcional)',
    cancel: 'Cancelar',
    confirm: 'Inativar',
    errors: {
      noteMaxLength: 'A observação deve ter no máximo {{max}} caracteres',
      generic: 'Não foi possível inativar o cliente',
    },
  },
  messageComposer: {
    title: 'Enviar mensagem',
    selectPlaceholder: 'Escolha um template',
    preview: 'Prévia',
    copy: 'Copiar',
    copied: 'Mensagem copiada',
    copyError: 'Não foi possível copiar a mensagem',
    openWhatsApp: 'Abrir no WhatsApp',
    noPhone: 'Este cliente não possui telefone cadastrado.',
    empty: 'Nenhum template de mensagem',
    emptyHint: 'Crie templates em Configurações para reutilizá-los aqui.',
    close: 'Fechar',
  },
};

export default leadTranslatePTBR;
